<template>
  <PAccordion
    :version="2"
    :label="`${pendingSignStore.list.length} ${replacePlural(pendingSignStore.list.length, 'signature apposée', 'signatures apposées')}`"
    v-model:open="pendingSignOpen"
    contentClass="border border-grey-850 max-h-[250px] overflow-y-scroll"
  >
    <ul>
      <li
        v-for="{ pageIndex, pendingSign } in pages"
        :key="pageIndex"
        class="flex flex-row justify-between items-center"
      >
        <button type="button" @click="goToPage(pageIndex)" class="group pl-2">
          Page {{ pageIndex + 1 }}
          <span class="rounded-full px-1 py-0.5 ml-1 bg-green-emeraude-950 group-hover:bg-green-emeraude-950-hover">
            {{ pendingSign.length }} {{ plural("signature", pendingSign.length) }}
          </span>
        </button>
        <button type="button" @click="deletePendingSignPage(pageIndex)">
          <PTooltip :label="`Supprimer signature(s) apposée(s) page ${pageIndex + 1}`" :offset="5" :delay="500">
            <div class="p-1 rounded-full text-blue-france-sun-113 hover:text-white hover:bg-blue-france-sun-113-hover">
              <OhVueIcon scale="1" :name="deleteIcon" />
            </div>
          </PTooltip>
        </button>
      </li>
    </ul>
    <PButton
      v-if="pages.length > 1"
      type="button"
      mode="tertiary"
      color="error"
      size="sm"
      @click="deleteAllPendingSign"
      class="mt-2 w-full"
    >
      <OhVueIcon :name="deleteIcon" scale="0.8" class="mr-1" />
      Tout supprimer
    </PButton>
  </PAccordion>
</template>

<script setup lang="ts">
import { usePendingSignaturesStore } from "@/app/stores/pending-signatures.store.ts";
import { plural, replacePlural } from "@/app/utils/plural.ts";
import { AbstractSignObject } from "@/app/views/PdfViewer/domain/abstract.sign-object.domain.ts";
import type { PendingSignature } from "@/app/views/PdfViewer/domain/pending-signature.domain.ts";
import { PAccordion, PButton, PTooltip, useIcons } from "@pasta/box-v2";
import { sortBy } from "lodash";
import { OhVueIcon } from "oh-vue-icons";
import { RiDeleteBin6Line } from "oh-vue-icons/icons";
import { computed, ref } from "vue";
import { useSignEvents } from "../composable/use-sign-events.ts";

const [deleteIcon] = useIcons(RiDeleteBin6Line);

const pendingSignStore = usePendingSignaturesStore();

const pendingSignOpen = ref<boolean>(false);

const pages = computed(() => {
  const signPerPage: Map<number, PendingSignature[]> = pendingSignStore.list.reduce((acc, curr) => {
    const pageIndex = curr.coordinates.pageIndex;
    acc.set(pageIndex, [...(acc.get(pageIndex) ?? []), curr]);
    return acc;
  }, new Map());

  return sortBy(
    Array.from(signPerPage.entries()).map(([pageIndex, pendingSign]) => ({
      pageIndex: +pageIndex,
      pendingSign,
    })),
    "pageIndex"
  );
});
const signEvents = useSignEvents();

function goToPage(pageIndex: number) {
  const page = pages.value.find(page => page.pageIndex === pageIndex)!;
  const firstPendingSign = AbstractSignObject.sort(page.pendingSign)[0];
  firstPendingSign.scrollTo();
}

function deletePendingSignPage(pageIndex: number) {
  signEvents.emit("deleteObjects", "pendingSign", pageIndex);
}

function deleteAllPendingSign() {
  signEvents.emit("deleteObjects");
}
</script>
